<!--参考模板-->
<template>
	<div class="drop-position refer" ref="config" :style="concludeWH">
		<vue-drag-resize
			class="mark-out-position"
			:x="referRectDetail.areaMinX"
			:y="referRectDetail.areaMinY"
			:w="operateWidth(referRectDetail)"
			:h="operateHeight(referRectDetail)"
		>
			<template>
				<div class="rect-title-wrap"></div>
			</template>
		</vue-drag-resize>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import VueDragResize from 'vue-drag-resize'
import isDragResize from '@/views/template-configuration/utils/mixin/is-drag-resize'
import drawRect from '@/views/template-configuration/utils/mixin/draw-rect'
import fixWH from '@/views/template-configuration/utils/mixin/fix-wh'
import fixRect from '@/views/template-configuration/utils/mixin/fix-rect'
export default {
	name: 'temp-refer',
	mixins: [isDragResize, drawRect, fixWH, fixRect],
	components: {
		VueDragResize
	},
	data() {
		return {
			//微信信息
			referRectDetail: {
				areaMinX: 0,
				areaMinY: 0,
				areaMaxX: 0,
				areaMaxY: 0
			},
			rectObjDetail: [],
			emitType: 'tempObjSelRefer',
			topicTitle: '',
			currentImg: ''
		}
	},
	watch: {
		//当前试卷
		tempEditImgInfo: {
			handler(val) {
				this.currentImg = val.list[this.tempCurrentImgIndex.curIndex]
			},
			deep: true,
			immediate: true
		},
		//当前试卷
		tempCurrentImgIndex(val) {
			this.currentImg = this.tempEditImgInfo.list[val.curIndex]
		}
	},
	computed: { ...mapGetters('examination/configation', ['tempEditImgInfo', 'tempCurrentImgIndex']) },
	methods: {
		...mapActions('examination/databases', ['set', 'get'])
	}
}
</script>

<style scoped lang="less">
@import '../utils/css/mark-point.less';
</style>
